import { render, staticRenderFns } from "./genericbulkdeletemodal.vue?vue&type=template&id=3d10df24&scoped=true"
import script from "./genericbulkdeletemodal.vue?vue&type=script&lang=js"
export * from "./genericbulkdeletemodal.vue?vue&type=script&lang=js"
import style0 from "./genericbulkdeletemodal.vue?vue&type=style&index=0&id=3d10df24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d10df24",
  null
  
)

export default component.exports